module.exports = __webpack_public_path__ + "img/logo4.dd979728.png";